import template from './total-area-garage.jade';

export default angular
  .module('cian.addForm.totalAreaGarage', ['cian.addForm.totalArea'])
  .directive('cianAfAboutObjectTotalAreaGarage', () => ({
    scope: {},
    bindToController: {
      ad: '=',
      form: '=',
    },
    controller: [
      function () {
        this.validationMessages = {
          required: 'Укажите площадь гаража',
        };
      },
    ],
    controllerAs: 'totalAreaGarage',
    template,
  })).name;
